import { render, staticRenderFns } from "./SubmissionDueDateText.vue?vue&type=template&id=b86380c6&lang=pug&"
import script from "./SubmissionDueDateText.vue?vue&type=script&lang=js&"
export * from "./SubmissionDueDateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports